import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'homi-data-list-item',
  templateUrl: 'data-list-item.component.html',
  styleUrls: ['data-list-item.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataListItemComponent {}
